import $ from 'jquery'

const toggleInquiryKind = () => {
  let trouble = $('.js-inquiryTrouble')
  if ($('.js-inquiryKind').val() === '1') {
    trouble.show()
  } else {
    trouble.hide()
  }
}

const togglePrivacy = () => {
  let button = $('.js-button')
  if ($('.js-privacy').prop('checked')) {
    button.css('opacity', '1').removeAttr('disabled')
  } else {
    button.css('opacity', '0.3').attr('disabled', 'disabled')
  }
}

const changeInquiryKind = () => {
  toggleInquiryKind()
  $('.js-inquiryKind').on('change', () => {
    toggleInquiryKind()
  })
}

const changePrivacy = () => {
  togglePrivacy()
  $('.js-privacy').on('click', () => {
    togglePrivacy()
  })
}

const start = () => {
  $('.js-inquiryTrouble').hide()
  changeInquiryKind()
  changePrivacy()
}

$(() => {
  start()
})



// WEBPACK FOOTER //
// ./src/scripts/page/inquiry.js